import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const links = [
  {
    to: "/tools/caregiver-burnout-check",
    title: "Free: Caregiver Burnout Self-Check",
    blurb: "Two minutes, no email required — an honest read on how close to the edge you actually are.",
  },
  {
    to: "/senior-companion-care-nashville",
    title: "Senior companion care in Nashville",
    blurb: "What concierge companion care includes, how matching works, and what to expect week to week.",
  },
  {
    to: "/resources/caregiver-burnout-signs",
    title: "Caregiver burnout: the signs most people miss",
    blurb: "The symptoms that don't look like burnout until you name them — and what helps at each stage.",
  },
  {
    to: "/resources/cost-of-companion-care-nashville",
    title: "What companion care costs in Nashville",
    blurb: "Plain-language pricing, what's included, and how private care compares to agency hourly rates.",
  },

  {
    to: "/resources/signs-loved-one-needs-companion-care",
    title: "Signs a loved one needs support",
    blurb: "Ten quiet changes families notice first — and what each one usually means.",
  },
  {
    to: "/resources/how-to-talk-to-aging-parent-about-help",
    title: "How to start the conversation",
    blurb: "A gentle script for talking with a parent who insists they're fine.",
  },
  {
    to: "/services",
    title: "Our full care menu",
    blurb: "Mobility support, transportation, meals, wellness visits, weekend and overnight care.",
  },
  {
    to: "/resources/local-help",
    title: "Nashville senior resources",
    blurb: "Local programs, transportation options, and support lines worth bookmarking.",
  },
];

const KeepExploring = () => (
  <section className="py-20 md:py-28 bg-background" aria-labelledby="keep-exploring-heading">
    <div className="container">
      <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink text-center mb-4 font-medium">Keep Exploring</p>
      <h2 id="keep-exploring-heading" className="text-3xl md:text-4xl font-heading font-semibold text-center mb-6">
        Helpful Reading for Nashville Families
      </h2>
      <div className="w-16 h-px bg-warm mx-auto mb-14" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="group block bg-card border border-border rounded-xl p-6 hover:shadow-md transition-shadow"
          >
            <h3 className="font-heading font-semibold mb-2 leading-snug group-hover:underline">{l.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed mb-3">{l.blurb}</p>
            <span className="inline-flex items-center text-sm text-warm-ink font-medium">
              Read: {l.title} <ArrowRight className="h-3.5 w-3.5 ml-1" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default KeepExploring;
